
document.addEventListener("DOMContentLoaded", () => {

  /* Default to color sort. */
  
  var x = document.querySelectorAll("[sorter]");
  if (x.length > 0) {
    var sortby = localStorage.getItem("sortby");
    if (sortby == null || sortby == "instock") {
      sortby = "color";
    }
    var order = localStorage.getItem("order");
    if (order == null) {
      order = "asc";
    }
    var b = document.querySelectorAll("[sortby='" + sortby + "']");
    if (b.length > 0) {
      /*
      console.log(sortby);
      b[0].click(); 
      */
      
    }
     
  }
});